module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.header),
      expression: "header"
    }],
    staticClass: "panel-heading"
  }, [_vm._t("header")], 2), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_vm._t("body")], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.footer),
      expression: "footer"
    }],
    staticClass: "panel-footer"
  }, [_vm._t("footer")], 2)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b9864d88!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/root/main/ModulePanelTemplate.vue
// module id = 960
// module chunks = 2